import React, { useCallback, useRef, useState } from "react";
import { Share2, MessageCircle, Mail, Link2, Check } from "lucide-react";
import PickerPopover from "./PickerPopover";

/** Copia al portapapeles, con respaldo para navegadores sin permiso o sin https. */
const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const helper = document.createElement("textarea");
    helper.value = text;
    helper.setAttribute("readonly", "");
    helper.style.position = "fixed";
    helper.style.opacity = "0";
    document.body.appendChild(helper);
    helper.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(helper);
    return ok;
  }
};

/**
 * Botón de compartir con WhatsApp, correo o copiar enlace.
 *
 * `title` encabeza el mensaje, `lines` son los datos que lo acompañan (fecha,
 * hora, sitio…) y `url` es el enlace que se comparte y se copia. El panel
 * reutiliza `PickerPopover`, así que también funciona dentro de un modal.
 */
function ShareMenu({
  title,
  lines = [],
  url,
  label = "Compartir",
  className = "dyd-btn dyd-btn-ghost dyd-btn-block",
}) {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const close = useCallback(() => setOpen(false), []);

  const message = [title, ...lines.filter(Boolean), url].filter(Boolean).join("\n");

  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  const mailUrl =
    `mailto:?subject=${encodeURIComponent(title || "")}` +
    `&body=${encodeURIComponent(message)}`;

  const handleCopy = async () => {
    const ok = await copyToClipboard(url);
    if (!ok) {
      alert("No se ha podido copiar el enlace. Cópialo a mano: " + url);
      return;
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        className={className}
        aria-expanded={open}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((v) => !v);
        }}
      >
        <Share2 size={16} />
        {label}
      </button>

      <PickerPopover anchorRef={anchorRef} open={open} onClose={close} minWidth={212}>
        <div className="dyd-share-menu">
          <a
            className="dyd-share-option"
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
          >
            <MessageCircle size={17} />
            WhatsApp
          </a>

          <a className="dyd-share-option" href={mailUrl} onClick={close}>
            <Mail size={17} />
            Correo
          </a>

          <button
            type="button"
            className={`dyd-share-option ${copied ? "is-done" : ""}`}
            onClick={handleCopy}
          >
            {copied ? <Check size={17} /> : <Link2 size={17} />}
            {copied ? "¡Enlace copiado!" : "Copiar enlace"}
          </button>
        </div>
      </PickerPopover>
    </>
  );
}

export default ShareMenu;
